// Auth-specific query keys factory
export const authQueryKeys = {
	// Base key for all auth queries
	all: ['auth'] as const,

	// Authentication state queries
	state: () => [...authQueryKeys.all, 'state'] as const,
	isAuthenticated: () => [...authQueryKeys.state(), 'isAuthenticated'] as const,

	// User profile queries
	profiles: () => [...authQueryKeys.all, 'profile'] as const,
	profile: () => [...authQueryKeys.profiles(), 'current'] as const,
	profileById: (id: string | number) => [...authQueryKeys.profiles(), id] as const,

	// Session queries
	sessions: () => [...authQueryKeys.all, 'session'] as const,
	currentSession: () => [...authQueryKeys.sessions(), 'current'] as const,

	// Token queries
	tokens: () => [...authQueryKeys.all, 'token'] as const,
	tokenValidation: (token: string) => [...authQueryKeys.tokens(), 'validate', token] as const,
} as const;
